import { render, staticRenderFns } from "./SVGNavbarUser.vue?vue&type=template&id=4d336e1c&scoped=true&"
import script from "./SVGNavbarUser.vue?vue&type=script&lang=js&"
export * from "./SVGNavbarUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d336e1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d336e1c')) {
      api.createRecord('4d336e1c', component.options)
    } else {
      api.reload('4d336e1c', component.options)
    }
    module.hot.accept("./SVGNavbarUser.vue?vue&type=template&id=4d336e1c&scoped=true&", function () {
      api.rerender('4d336e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGNavbarUser.vue"
export default component.exports